import {IApiEndpoints} from "../typings/apiEndpoints";
import * as angular from "angular";

export class TextblockResource {
    public static $inject = ["$q", "$http", "ApiEndpoints"];
    constructor(
        private $q: angular.IQService,
        private $http:angular.IHttpService,
        private ApiEndpoints:IApiEndpoints
    ) {
    }

    public getQuickrulesForLeague(leagueId:number, language?: string): angular.IPromise<string> {
        return this.$http.get(this.ApiEndpoints.league + '/' + leagueId + '/quickrules', {
            params: {language: language}
        })
        .then((response: angular.IHttpPromiseCallbackArg<string>) => {
            return response.data;
        })
        .catch(reason => {
            if (reason.status < 500) {
                return "";
            }

            return this.$q.reject(reason);
        }) as any;
    }
}
